<template>
  <rc-layout/>
</template>
<script>
  export default {
    name: 'RcMain',
    components: {
      RcLayout: () => import(/* webpackChunkName: "rrc-core" */'@/layout')
    }
  }
</script>
